export default {
	messages: {
	  required: (field) => `Este campo es requerido`,
	  length: (field) => `El campo está mal formado`,
	},
	custom : {
		email : {
			required : 'El campo email es obligatorio',
			email : 'Debes indicar una dirección de correo electrónico válida'
		},
		emailForget : {
			required : 'El campo email es obligatorio',
			email : 'El email está mal formado'
		},
		tipo_contacto : {
			required : 'El campo motivo de la consulta es obligatorio'
		},
		telefono : {
			required : 'El campo teléfono es obligatorio',
			length : 'El campo teléfono está mal formado',
			numeric: 'El campo teléfono está mal formado'
		},
		nombre : {
			required : 'El campo nombre es obligatorio'
		},
		mensaje : {
			required : 'El campo mensaje es obligatorio'
		},
		apellidos : {
			required : 'El campo apellidos es obligatorio'
		},
		'current-password' : {
			min : 'La contraseña debe contener como minimo 6 caracteres'
		},
		'new-password-0' : {
			min : 'La contraseña debe contener como minimo 6 caracteres'
		},
		'new-password-1' : {
			confirmed : 'Las contraseñas deben coincidir'
		},
		politica : {
			required : 'Debes aceptar la política de privacidad'
		},
		comunicaciones : {
			required : 'Debes aceptar el envio de comunicaciones'
		},
		referencia_producto : {
			required : 'El campo referencia del producto es obligatorio'
		},
		tipo_catalogo : {
			required : 'El campo tipo de Catálogo es obligatorio'
		},
		empresa : {
			required : 'El campo empresa es obligatorio'
		},
		direccion : {
			required : 'El campo direccion es obligatorio'
		},
		pais : {
			required : 'El campo pais es obligatorio'
		},
		area_interes : {
			required : 'El campo área de interes es obligatorio'
		},
		carta_presentacion : {
			required : 'El campo carta de presentación es obligatorio'
		},
		nombre_taller : {
			required : 'El campo nombre taller es obligatorio'
		},
		cif_taller: {
		  required: 'El campo nombre CIF es obligatorio'
		},
	}
}


// WEBPACK FOOTER //
// ./src/validator/es.js